import { Dayjs } from "dayjs";

export type Row = {
    key: string;
    id?: number;
    monthLabel: string;
    yearAndMonthRaw: string;
    v1?: string;
    v2?: string;
    v3?: string;
    v4?: string;
    v5?: string;
    title1?: string;
    title2?: string;
    title3?: string;
    title4?: string;
    title5?: string;
};

export type EditForm = {
    month?: Dayjs;
    v1?: string;
    v2?: string;
    v3?: string;
    v4?: string;
    v5?: string;
};

export const PAGE_SIZE = 12;
